import { Box } from "@mui/material";

export default function TabPanel({ label, children, ...props }) {
    return <Box {...props}>{children}</Box>;
}
